import { useRef } from "react";
export const useGetGerudoContainer = () => {
    const ref = useRef(null);
    const getGerudoContainer = () => {
        var _a;
        return ((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.closest(".gerudo")) || document.getElementById("gerudo") || document.body;
    };
    return {
        ref,
        getGerudoContainer,
    };
};
//# sourceMappingURL=useGetGerudoContainer.js.map